import { useEffect, useState } from "react";
import Form from "@/components/common/form/form";
import Model from "@/components/common/model.component";
import { useSwrGet } from "@/utils/use-swr-get";
import { authServices } from "services/auth.services";
import { setValveData } from "@/redux/actions/valves/valveData";
import ElectricitySourceForm from "./electricitySourceFrom";
import { ElectricitySourcesService } from "services/assets-electricitySource.services";
import { useDispatch, useSelector } from "react-redux";
import LocationModal from "./locationModal";
import { useTranslation } from "react-i18next";
import { readTreeFields } from "@/redux/actions/tree/fields";
import _objI from "@/utils/_objI";
import { creatGeo } from "@/redux/actions/geo";
import _objO from "@/utils/_objO";
import PageTitle from "components/common/page-title.component";

type Reducer = {
  treeFieldsReducer?: any;
  farmsReducer?: any;
};
type geo = { [x: string]: any };
export default function ElectricitySourceModal(props) {
  const { showModal, setShowModal, gboundary } = props;
  const dispatch = useDispatch();
  const [showLocationModal, setLocationModal] = useState(false);
  const { t } = useTranslation();

  const [icon, setIcon] = useState("GEN-");
  const {
    data: farmData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(
    `/farm/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `farms/details/${authServices.userValue.org_id}/`
  );
  const onSubmit = async (data) => {
    data.org_id = authServices.userValue.org_id;
    data.creation_date = new Date().toISOString().split("T")[0];
    data.content_type = farmData
      ?.filter?.((item) => item.farm_id == data.farm_id)
      ?.map?.((item) =>
        item.farm_type === "tree"
          ? authServices.userValue.content_types
              ?.filter?.((item) => item.model == "treefieldinfo")
              ?.find?.((item) => item.id)?.id
          : authServices.userValue.content_types
              ?.filter?.((item) => item.model == "pivotfieldinfo")
              ?.find?.((item) => item.id)?.id
      )[0];
    data.generator_code = "GEN-" + data.generator_code;
    data.efficiency = Number(data.efficiency);
    data.entity_type_id = 8;
    data.farm_id = Number(data.farm_id);
    data.object_id = Number(data.object_id);
    data.power_capacity = Number(data.power_capacity) || 0;
    data.supplier_id = Number(data.supplier_id) || null;
    data.tank_capacity = Number(data.tank_capacity) || 0;
    let res = await ElectricitySourcesService.addElectricitySources(data);

    if (gboundary) {
      let geo: geo = await dispatch(creatGeo(gboundary));
      data.gboundary_id = geo.data.id;
    } else {
      setLocationModal(true);
    }

    if (res) {
      dispatch(
        setValveData({
          id: res.data.id,
          entity_type_id: res.data.entity_type_id,
        })
      );

      setShowModal(false);
    }
  };
  const { field } = useSelector((state: Reducer) => state.treeFieldsReducer);
  let removeMarker = () => {
    let marker = Array?.from?.(
      document?.getElementsByClassName?.("leaflet-marker-icon")
    );
    marker?.forEach?.((box, index) => {
      index === marker.length - 1 ? box.remove() : null;
    });
  };
  const { farm } = useSelector((state: Reducer) => state.farmsReducer);

  useEffect(() => {
    dispatch(readTreeFields(`?farm_id__id=${farm.id}`));
  }, [farm.id]);
  return (
    <>
      <Model
        width="w-130"
        show={showModal}
        onClose={(e) => {
          setShowModal(false);
          removeMarker?.();
        }}
      >
        <PageTitle title={t("AddElectricitySource")} titletextSize="text-xl" />

        <Form
          onSubmit={onSubmit}
          defaultValues={
            _objI(field) || _objI(farm)
              ? {
                  object_id: field?.id ?? "",
                  farm_id: farm?.id ?? "",
                }
              : {}
          }
        >
          <ElectricitySourceForm RowData={""} passProps icon={icon} />
        </Form>
      </Model>
      <LocationModal
        setRefresh={props.setRefresh}
        showModal={showLocationModal}
        setShowModal={setLocationModal}
        closeMainModal={setShowModal}
      />
    </>
  );
}
